import React from "react";

const wheel = ({ fill = "black" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.692"
      height="21.692"
      viewBox="0 0 21.692 21.692"
      fill={fill}
    >
      <g id="Group_53798" data-name="Group 53798" transform="translate(0 0)">
        <g id="Group_50979" data-name="Group 50979" transform="translate(0 0)">
          <g id="Group_50978" data-name="Group 50978">
            <path
              id="Path_206699"
              data-name="Path 206699"
              d="M181.652,100.794a10.845,10.845,0,1,0,5.423,1.453,10.846,10.846,0,0,0-5.423-1.453Zm0,2.712a8.135,8.135,0,0,1,7.667,5.423H173.985a8.135,8.135,0,0,1,7.667-5.423Zm0,8.135v0Zm-8.135,0h2.711a4.068,4.068,0,0,1,4.068,4.067v3.952a8.135,8.135,0,0,1-6.779-8.02Zm9.491,8.02v-3.952a4.068,4.068,0,0,1,4.068-4.067h2.711a8.135,8.135,0,0,1-6.779,8.02Z"
              transform="translate(-170.806 -100.794)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default wheel;
